import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { AdminLayout } from "../../components/admin/AdminLayout";
import { StatusBadge } from "../../components/StatusBadge";

export default function AdminApplications() {
  const navigate = useNavigate();
  useEffect(() => { document.title = "Partner Applications | Sambiva Admin"; }, []);
  const { data: apps = [] } = useQuery({ queryKey: ["admin-applications"], queryFn: async () => (await api.get("/admin/applications")).data });

  return (
    <AdminLayout title="Partner Applications">
      <div className="bg-white rounded-2xl border border-black/5 overflow-x-auto">
        <table className="w-full text-sm min-w-[760px]">
          <thead className="bg-[#f6f7f9] text-sambiva-muted text-left">
            <tr><th className="px-4 py-3 font-semibold">Company</th><th className="px-4 py-3 font-semibold">Contact</th><th className="px-4 py-3 font-semibold">Country</th><th className="px-4 py-3 font-semibold">Type</th><th className="px-4 py-3 font-semibold">Applied</th><th className="px-4 py-3 font-semibold">Status</th></tr>
          </thead>
          <tbody>
            {apps.map((a) => (
              <tr key={a.id} data-testid={`app-row-${a.id}`} onClick={() => navigate(`/admin/customers/${a.id}`)} className="border-t border-black/5 hover:bg-sambiva-cream/30 cursor-pointer">
                <td className="px-4 py-3 font-medium text-sambiva-charcoal">{a.company_name}</td>
                <td className="px-4 py-3 text-sambiva-muted">{a.contact_name}</td>
                <td className="px-4 py-3 text-sambiva-muted">{a.country}</td>
                <td className="px-4 py-3 text-sambiva-muted">{a.business_type}</td>
                <td className="px-4 py-3 text-sambiva-muted">{new Date(a.created_at).toLocaleDateString()}</td>
                <td className="px-4 py-3"><StatusBadge status={a.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        {apps.length === 0 && <div className="p-10 text-center text-sambiva-muted">No applications yet.</div>}
      </div>
    </AdminLayout>
  );
}
